export const form = {
  date: 'Czas aktywności',
} as const
